import { getContractList } from "api/contract_list";
import { useState } from "react";
import { useMutation } from "react-query";
import { PredictiveSearchField } from "ui/PredictiveSearch";
import getErrorText from "utils/getErrorText";
import { FieldProps } from "./types";

const ParentContractField = ({
  control,
  errors,
  contractLoading,
  isShown,
  isRequired,
  watch
}: FieldProps) => {
  const parentContract = watch("parent_contract") as number | undefined;
  const [searchParentContractValue, setSearchParentContractValue] = useState<string>();

  const {
    mutate: parentContractSearchRequest,
    isLoading: parentContractSearchLoading,
    data: parentContractSearchResponse
  } = useMutation({
    // mutationFn: searchMutationContract(searchParentContractValue)
    mutationFn: () =>
      getContractList(
        searchParentContractValue
          ? { search: searchParentContractValue }
          : { filter: parentContract ? { id: [parentContract] } : {} }
      )
  });

  if (!isShown) return null;

  console.log(parentContractSearchResponse);

  return (
    <div className="row align-items-center">
      <div className="col-sm-9">
        <PredictiveSearchField
          name="parent_contract"
          title="Выберите договор к которому относится ДС"
          optionKey={["contract_number", "extra_fields.client.inn", "id", "status"]}
          optionKeyLabels={["№ договора", "ИНН заказчика", "ID", "hidden"]}
          inputValue={searchParentContractValue}
          setInputValue={setSearchParentContractValue}
          control={control}
          errors={errors}
          errorText={getErrorText(errors, "client", "Должно быть заполнено.")}
          isLoading={parentContractSearchLoading}
          request={parentContractSearchRequest}
          response={parentContractSearchResponse}
          disabled={contractLoading}
          optionDisableCondition={{ status: 2 }}
          infoText="Нельзя выбрать договоры, статус которых &lsquo;ЧЕРНОВИК&rsquo;"
          isRequired={isRequired !== null ? isRequired : false}
          isStared={isRequired !== null}
          clearable
        />
      </div>
    </div>
  );
};

export default ParentContractField;
